import { jsx as _jsx } from "react/jsx-runtime";
import { StyledVideoButton } from "./VideoButton.styles";
export const VideoButton = ({ className, disabled, size: sizeString = "standard", onClick, }) => (_jsx(StyledVideoButton, { onClick: onClick, symbol: "Play", stylingType: "video", className: className, disabled: disabled, size: sizeString, "data-testid": "video-button-input" }));
